// Job status constants and display helpers — shared between JobsView and any
// future components that need to render job status badges or formatted dates.

export const JOB_STATUS = {
  STARTED: "started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const JOB_TYPE = {
  REQUESTED: "Requested",
  HOME_REPAIR: "HomeRepair",
  CAR_REPAIR: "CarRepair",
};

export const formatDate = (dateString) =>
  new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export const getStatusColor = (status) => {
  switch (status) {
    case JOB_STATUS.STARTED:
      return "text-yellow-600 bg-yellow-100";
    case JOB_STATUS.IN_PROGRESS:
      return "text-ink-teal bg-terracotta-50";
    case JOB_STATUS.COMPLETED:
      return "text-green-600 bg-green-100";
    case JOB_STATUS.CANCELLED:
      return "text-red-600 bg-red-100";
    default:
      return "text-ink-soft bg-cream";
  }
};

export const formatStatus = (status) =>
  status.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase());
